import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getChannelMessageListLoading: false,
  getChannelMessageListFailed: false,
  getChannelMessageListReject: false,
  getChannelMessageListMessage: [],
  ChannelMessageList: [],

  getNewsListLoading: false,
  getNewsListFailed: false,
  getNewsListReject: false,
  getNewsListMessage: false,
  newsList: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CHANNEL_MESSAGE_LIST_LOADING: {
      return {
        ...state,
        getChannelMessageListLoading: true,
        getChannelMessageListFailed: false,
        getChannelMessageListReject: false,
        getChannelMessageListMessage: [],
        ChannelMessageList: [],
      };
    }
    case actionTypes.GET_CHANNEL_MESSAGE_LIST_SUCCESS: {
      return {
        ...state,
        getChannelMessageListLoading: false,
        getChannelMessageListFailed: false,
        getChannelMessageListReject: false,
        getChannelMessageListMessage: [],
        ChannelMessageList: action.payload.channelMessages,
      };
    }
    case actionTypes.GET_CHANNEL_MESSAGE_LIST_FAILED: {
      return {
        ...state,
        getChannelMessageListLoading: false,
        getChannelMessageListFailed: true,
        getChannelMessageListReject: false,
        getChannelMessageListMessage: [],
        ChannelMessageList: [],
      };
    }
    case actionTypes.GET_CHANNEL_MESSAGE_LIST_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getChannelMessageListLoading: false,
        getChannelMessageListFailed: false,
        getChannelMessageListReject: true,
        getChannelMessageListMessage: message,
        ChannelMessageList: [],
      };
    }

    case actionTypes.GET_NEWS_LIST_LOADING: {
      return {
        ...state,
        getNewsListLoading: true,
        getNewsListFailed: false,
        getNewsListReject: false,
        getNewsListMessage: false,
        newsList: [],
      };
    }
    case actionTypes.GET_NEWS_LIST_SUCCESS: {
      return {
        ...state,
        getNewsListLoading: false,
        getNewsListFailed: false,
        getNewsListReject: false,
        getNewsListMessage: false,
        newsList: action.payload.newsMessages,
      };
    }
    case actionTypes.GET_NEWS_LIST_FAILED: {
      const { message } = action.payload;

      return {
        ...state,
        getNewsListLoading: false,
        getNewsListFailed: true,
        getNewsListReject: false,
        getNewsListMessage: message,
        newsList: [],
      };
    }
    case actionTypes.GET_NEWS_LIST_REJECT: {
      return {
        ...state,
        getNewsListLoading: false,
        getNewsListFailed: true,
        getNewsListReject: true,
        getNewsListMessage: [],
        newsList: [],
      };
    }

    default:
      return state;
  }
};
